module.exports = __webpack_public_path__ + "static/media/check-circle-white.c2aba12c.svg";